export default function getResource(label, vars = []) {
    const resources = {
        search: 'Search',
        searchStore: 'Search this store',
        searchLocation: 'Search this location',
        cancel: 'Cancel',
        previousSearches: 'Previous Searches',
        clearInputAriaLabel: 'clear search input text',
        trendingCategories: 'Trending Categories',
        searchSuggestions: 'Search Suggestions',
        productSuggestions: 'Product Suggestions',
        continueBrowsing: 'Continue Browsing',
        buyItAgain: 'Buy It Again',
        purchased: 'Purchased',
        suggestionsAvailable: `${vars[0]} search suggestions available`,
        noSuggestionsAvailable: 'No suggestions available',
        optionPosition: `${vars[0]} of ${vars[1]}`
    };

    return resources[label];
}
